import AccountSettings from '@/pages/account-settings/AccountSettings';

export default AccountSettings;
